import { ModalBase } from '@findy-code/yuffie/ui/modal';
import { CircleCloseButton } from '@findy-code/yuffie/ui/modal/components/close-button';
import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import styles from './company-detail-event-modal.component.module.scss';
type Props = {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
};

// memo: モーダルの開閉に関しては親コンポーネントで行っているためテスト対象外とします。またonPlay時のテストに関してもライブラリの挙動に依存するためテスト対象外とします。
export const CompanyDetailEventModal = ({
  isOpen,
  onClose,
  videoUrl,
}: Props) => {
  const ref = useRef<ReactPlayer>(null);
  const [currentMovieTime, setCurrentMovieTime] = useState<number>(0);

  const handleCloseModal = () => {
    if (ref.current) setCurrentMovieTime(ref.current.getCurrentTime());
    onClose();
  };

  const handleVideoPlay = () => {
    if (ref.current && currentMovieTime) {
      ref.current.seekTo(currentMovieTime, 'seconds');
      setCurrentMovieTime(0);
    }
  };

  return (
    <ModalBase
      className={styles.content}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
    >
      <div className={styles.contentInner}>
        <ReactPlayer
          controls
          className={styles.videoPlayer}
          height="auto"
          playing={currentMovieTime > 0}
          ref={ref}
          url={videoUrl}
          width="100%"
          onPlay={handleVideoPlay}
        />
        <CircleCloseButton
          aria-label="閉じる"
          className={styles.closeButton}
          type="button"
          onClick={handleCloseModal}
        />
      </div>
    </ModalBase>
  );
};
